import React from 'react';
import * as R from 'ramda';
import PropTypes from 'prop-types';
import {Button} from 'react-bootstrap';

import AdModeOption from 'js/campaign_analytics/v2/campaign_analytics_page/posts/ad_mode/ad_mode_option';

import AdModeSubmissionCTAs from 'js/campaign_analytics/v2/campaign_analytics_page/posts/ad_mode/submission_ctas/index';

import {VIEWS as AdModeInfoViews} from '../../index';

export default function SelectPlatformAndPublish(props) {
    const {
        activePlatforms,
        platform,
        format,

        handleChangePlatform,
        hasDesktopOption,
        handleExitAdMode,
        handleChangeFormat,
        handleChangeView
    } = props;

    const platformOptions = R.map(
        platformName => (
            <AdModeOption
                onClick={handleChangePlatform}
                current={platform}
                name={platformName}
                key={platformName}
            />
        ),
        activePlatforms
    );

    const AdModeSubmissionCTA = R.prop(platform, AdModeSubmissionCTAs);

    return (
        <div>
            <div className="ad-mode-container">
                <div className="ad-mode-info-title">
                    See a preview of your ad on the left before you run:
                </div>
                <div className="ad-mode-info-label">Select your platform:</div>
                <div className="ad-mode-options">{platformOptions}</div>
                <div className="ad-mode-info-label">Select your format:</div>
                <div className="ad-mode-options">
                    <AdModeOption onClick={handleChangeFormat} current={format} name="mobile" />
                    {hasDesktopOption(platform) && (
                        <AdModeOption
                            onClick={handleChangeFormat}
                            current={format}
                            name="desktop"
                        />
                    )}
                </div>
            </div>
            <div className="ad-mode-buttons">
                <AdModeSubmissionCTA
                    {...props}
                    handleBoardSelected={boardId =>
                        handleChangeView(
                            boardId === 'create-board'
                                ? AdModeInfoViews.CREATE_BOARD
                                : AdModeInfoViews.CREATE_PIN,
                            {boardId}
                        )
                    }
                    handleShowConnectToPlatform={() =>
                        handleChangeView(AdModeInfoViews.AUTHENTICATE)
                    }
                />

                <Button
                    bsSize="small"
                    bsStyle="default"
                    className="ad-mode-go-back-btn"
                    onClick={handleExitAdMode}
                >
                    <i className="fa fa-chevron-left" aria-hidden="true" />
                    <span> Back To Original Image</span>
                </Button>
            </div>
        </div>
    );
}

SelectPlatformAndPublish.propTypes = {
    activePlatforms: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    platform: PropTypes.string.isRequired,
    format: PropTypes.string.isRequired,

    hasDesktopOption: PropTypes.func.isRequired,
    handleExitAdMode: PropTypes.func.isRequired,
    handleChangePlatform: PropTypes.func.isRequired,
    handleChangeFormat: PropTypes.func.isRequired,
    handleChangeView: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/ad_mode/ad_mode_info/components/views/select_platform_and_publish.js